module.exports = __webpack_public_path__ + "media/images/svg/clients/15-7768abb560cc4fd6d966d561f704d0e8.svg";